import { Div, DivProps, P } from '@kizi/core-components';
import { IconV2 as Icon, IconV2Props } from '@kizi/shared-components';
import React from 'react';
import { Desktop, Mobile } from '../utils/breakpoint';
import {
  ComponentDescriptorOrArray,
  getRendererFromDescriptor,
} from '@kizi/comparator-core';

export interface BannerProps extends DivProps {
  body?: string;
  htmlBody?: string;
  iconName: string;
  iconProps?: IconV2Props;
  title?: string;
  variant?: string;
  breakpoint?: string;
  show?: boolean;
  content?: {
    title: string;
    body: string;
  }[];
  textVariant?: string;
  descriptor?: ComponentDescriptorOrArray;
}

export const Banner: React.FC<BannerProps> = React.forwardRef<
  HTMLDivElement,
  BannerProps
>(
  (
    {
      body,
      iconName,
      iconProps,
      title,
      htmlBody,
      variant = 'bannerInfo',
      breakpoint,
      show = true,
      textVariant,
      display = 'flex',
      content,
      descriptor,
      ...divProps
    },
    ref,
  ) => {
    let bodyContent = <></>;
    if (htmlBody) {
      bodyContent = (
        <Div
          css={{
            '>p': { my: '16px', maxWidth: '100%', color: textVariant || '' },
          }}
          dangerouslySetInnerHTML={{ __html: htmlBody }}
        ></Div>
      );
    } else if (body) {
      bodyContent = <P variant={textVariant || ''}>{body}</P>;
    }
    let bannerContent = (
      <Div
        alignItems={['flex-start', 'center']}
        display={display}
        flexDirection={['column', 'row']}
        ref={ref}
        variant={variant}
        {...divProps}
      >
        {iconName && <Icon name={iconName} {...iconProps} />}
        <Div display="flex" flexDirection="column">
          {title && <P className="banner-title">{title}</P>}
          {bodyContent}
        </Div>
        {content && (
          <Div display="flex" flexDirection="column">
            {content.map((textBlock, i) => (
              <Div
                key={i}
                display="flex"
                flexDirection="column"
                marginBottom={i !== content.length - 1 ? '30px' : '0'}
              >
                {<P variant="footnoteImportant">{textBlock.title}</P>}
                {<P variant="footnoteRegular">{textBlock.body}</P>}
              </Div>
            ))}
          </Div>
        )}
      </Div>
    );

    if (descriptor) {
      bannerContent = (
        <Div
          alignItems={['flex-start', 'center']}
          display={display}
          flexDirection={['column', 'row']}
          ref={ref}
          variant={variant}
          {...divProps}
        >
          <>{getRendererFromDescriptor(descriptor)}</>
        </Div>
      );
    }

    const breakpointWrapper = () => {
      switch (breakpoint) {
        case 'mobile':
          return <Mobile>{bannerContent}</Mobile>;
        case 'desktop':
          return <Desktop>{bannerContent}</Desktop>;
        default:
          return bannerContent;
      }
    };
    return show ? breakpointWrapper() : null;
  },
);
